import React from 'react'
import './style.scss'
import { useAuth } from '../../Provider/AuthProvider'
import StaffByClientTable from '../../components/Tables/Staff/StaffByClientTable'
const ReceptionistPage = () => {
  const { user } = useAuth()
  if (!user || !user.clientId) {
    return null
  }
  return (
    <div className='staffContainer'>
      <StaffByClientTable id={user.clientId} />
    </div>
  )
}

export default ReceptionistPage
